import React from "react";

function CountdownTimer({ expiresOn }) {
  //   console.log(expiresOn, "expiresOn");
  function parseExpiryDate() {
    if (expiresOn) {
      const [datePart, timePart] = expiresOn.split(" ");
      const [year, month, day] = datePart.split("-").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);
      return new Date(year, month - 1, day, hour, minute, second);
    }
    // fallback: 48 hours from now
    return new Date(Date.now() + 48 * 60 * 60 * 1000);
  }

  function getTimeLeft(expiryDate) {
    const now = new Date();
    const diff = expiryDate - now;

    if (diff <= 0) return "Expired";

    const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
    const minutes = String(
      Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    ).padStart(2, "0");
    const seconds = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(
      2,
      "0"
    );

    return `${hours}:${minutes}:${seconds}`;
  }

  const [timeLeft, setTimeLeft] = React.useState(() =>
    getTimeLeft(parseExpiryDate())
  );

  React.useEffect(() => {
    const expiryDate = parseExpiryDate();

    const timer = setInterval(() => {
      const updatedTime = getTimeLeft(expiryDate);
      setTimeLeft(updatedTime);

      if (updatedTime === "Expired") {
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [expiresOn]);

  return (
    <span
      style={{
        color: "rgb(255 146 0)",
        fontFamily: "monospace",
        fontSize: 13,
        // borderRadius: 8,
        // padding: "4px 16px",
        // letterSpacing: 2,
        display: "inline-block",
        // boxShadow: "0 2px 8px #ffd20033",
      }}
    >
      {timeLeft}
    </span>
  );
}

export default CountdownTimer;
